<template>
    <div>
        <div class="flex flex-wrap">
            <div class="w-full md:w-3/4 md:pr-20">
                <form method="POST" v-if="!saving">
                    <div class="mb-12">
                        <label for="title" ref="title">
                            Event Title <span class="text-red">*</span>
                            <div class="text-sm font-sans-book">60 character maximum (including spaces). Character count: {{ characterCount }}</div>
                        </label>
                        <input id="title" type="text" name="title"
                            v-validate="'required|max:60'"
                            v-model="form.title">
                            <span v-show="errors.has('title')" class="error text-error-red text-lg">{{ errors.first('title') }}</span>
                    </div>

                    <div class="mb-12">
                        <label for="festival" ref="festival">
                            Select Event Calendar <span class="text-red">*</span>
                        </label>
                        <select id="festival" name="festival"
                            v-model="form.festival_id"
                            v-validate="'required'">
                            <option :value="null" disabled>Select an event calendar</option>
                            <option
                                v-for="festival in currentFestivals"
                                :key="festival.id"
                                :value="festival.id">{{ festival.title }} {{festival.datesTitle}}</option>
                        </select>
                        <span v-if="errors.has('festival')" class="error text-error-red text-lg">
                          {{ errors.first('festival').replaceAll('festival', 'event calendar') }}
                        </span>
                    </div>

                    <div class="mb-12">
                        <button class="button"
                            @click.stop.prevent="saveEvent" v-if="!saving">Save</button>
                            <span v-else>Saving...</span>
                    </div>
                </form>
                <div class="text-2xl text-center mb-4" v-else>Saving Event...</div>
            </div>
            <div class="w-full md:w-1/4 border-t-5 border-black pt-3 mt-10 md:mt-2">
                <p>PLEASE NOTE: Once you submit your event for review, you cannot change the title. You can still change it while your event is a draft.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import moment from "moment";
    import _ from "lodash";
    import validation from "../../../mixins/validation";
    import {analyticsDataLayer} from "../../../api/analyticsDataLayer";

    export default {
        name: "EventCreate",
        title: "Create Event",
        mixins: [validation],
        data: () => ({
            form: {
                title: "",
                festival_id: null
            },
            submitted: false,
            saving: false
        }),
        computed: {
            ...mapGetters({
                festivals: "festivals"
            }),
            currentFestivals() {
                return _.filter(this.festivals, { isInPast: false });
            },
            characterCount() {
                return this.form.title ? this.form.title.length : 0;
            },

            dateTest() {
                return moment();
            }
        },
        methods: {
            saveEvent() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.gotoFirstValidationError();
                        return;
                    }

                    this.createEvent();
                });
            },
            createEvent() {
                // this.saving = true

                axios
                    .post(this.$laroute.route("api.events.store"), this.form)
                    .then(response => {
                        const event = response.data.data;
                        this.$toasted.show("Event has been created");
                        this.$store.dispatch("setActiveEvent", { data: event });
                        this.$router.push(`/events/${event.id}/basics`);
                        analyticsDataLayer.emit('event_created');
                        this.saving = false;
                    });
            }
        },
        mounted() {
            this.$store.dispatch("getFestivals");
        }
    };
</script>
